import React from "react";
import "./App.css";
import SalaryCalculator from "./components/SalaryCalculator";

function App() {
  return (
    <div className="App">
      <SalaryCalculator />
    </div>
  );
}

export default App;